import React from "react";

function Carousel(props) {
  return (
    <div
      id="myCarousel"
      className="carousel slide bg-light"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        <div className="carousel-item active ">
          <picture>
            <source media="(min-width: 992px)" srcset="/img/2L.jpg" />
            <img
              src="/img/2s.jpg"
              className="d-block  img-responsive"
              alt="..."
            />
          </picture>
        </div>
        <div className="carousel-item">
          <picture>
            <source media="(min-width: 992px)" srcset="/img/3L.jpg" />
            <img
              src="/img/3s.jpg"
              className="d-block  img-responsive"
              alt="..."
            />
          </picture>
        </div>
        <div className="carousel-item">
          <picture>
            <source media="(min-width: 992px)" srcset="/img/10L.jpg" />
            <img
              src="/img/5s.jpg"
              className="d-block  img-responsive"
              alt="..."
            />
          </picture>
        </div>
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#myCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#myCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}

export default Carousel;

// .carousel-inner {
//   position: relative;
//   display: inline-block;
// }
// .carousel-inner:after {
//   content: "";
//   position: absolute;
//   left: 0;
//   top: 0;
//   width: 100%;
//   height: 100%;
//   display: inline-block;
//   background: -moz-linear-gradient(
//     top,
//     rgba(0, 47, 75, 0.5) 0%,
//     rgba(220, 66, 37, 0.5) 100%
//   ); /* FF3.6+ */
//   background: -webkit-gradient(
//     linear,
//     left top,
//     left bottom,
//     color-stop(0%, rgba(220, 66, 37, 0.5)),
//     color-stop(100%, rgba(0, 47, 75, 0.5))
//   ); /* Chrome,Safari4+ */
//   background: -webkit-linear-gradient(
//     top,
//     rgba(0, 47, 75, 0.5) 0%,
//     rgba(220, 66, 37, 0.5) 100%
//   );
//   background: -o-linear-gradient(
//     top,
//     rgba(0, 47, 75, 0.5) 0%,
//     rgba(220, 66, 37, 0.5) 100%
//   );
//   background: -ms-linear-gradient(
//     top,
//     rgba(0, 47, 75, 0.5) 0%,
//     rgba(220, 66, 37, 0.5) 100%
//   );
//   background: linear-gradient(
//     to bottom,
//     rgba(0, 47, 75, 0.5) 0%,
//     rgba(220, 66, 37, 0.5) 100%
//   );
//   filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#002f4b', endColorstr='#00000000',GradientType=0 );
// }
